import React, { useEffect, useState } from "react";
import { Form, Table, Image } from "react-bootstrap";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { NavLink, useHistory } from "react-router-dom";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../../reusableComponents/selectFilter";

import { serverApi } from "../../../../../config/Keys";
import axios from "axios";
import isEmpty from "../../../../../store/validation/is-Empty";
import { useSelector } from "react-redux";
import { ORDER_TYPE, PAYMENT_STATUS } from "../../../../../enums/OrderEnums";
import moment from "moment";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import {
  FilterMain,
  SortTopRight,
} from "../../superAdminRefferalsCode/InsidePages/ReferralUserComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import { MenuItem } from "@material-ui/core";
import { getSubCateogryWithCategoryId } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";

const ScanAndPayVendorReport = (props) => {
  const history = useHistory();
  const id =
    history.location.pathname.split("/")[
      history.location.pathname.split("/").length - 1
    ];
  const [reportData, setReportData] = useState([]);
  const [reportStat, setReportStat] = useState({});
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const [sort, setSort] = useState("");

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      getReportData("SCAN_AND_PAY", dateQuery);
    }
  }, [auth]);

  const getReportData = async (type, dateQuery) => {
    let data = await axios.get(`${serverApi}/admin/transactional`, {
      params: {
        transaction_type: type,
        vendorId: id,
        payment_captured: true,
        ...dateQuery,
      },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setReportData(data.data);
      Array.prototype.sum = function (prop) {
        var total = 0;
        for (var i = 0, _len = this.length; i < _len; i++) {
          total += this[i][prop];
        }
        return total;
      };

      setReportStat({ total: data.data.sum("amount") });
    }
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    getReportData("SCAN_AND_PAY", data);
  };

  const [filter, setFilter] = useState(false);
  const [filterData, setFilterData] = useState("");

  const [filterData_final, setFilterData_final] = useState("");

  const renderData = reportData
    .filter((item) => {
      return (
        // item?.order_id.toLowerCase().includes(search.toLowerCase()) ||
        item?.user_id?.first_name
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item?.user_id?.last_name.toLowerCase().includes(search.toLowerCase())
      );
    })
    .filter((i) => {
      if (filterData_final) {
        if (filterData_final === 1) {
          return i?.status === "captured";
        } else {
          return i?.status !== "captured";
        }
      }
      return true;
    })
    .sort((a, b) => {
      if (sort === 1) {
        if (new Date(a?.createdAt) < new Date(b?.createdAt)) return -1;
        if (new Date(a?.createdAt) > new Date(b?.createdAt)) return 1;
        return 0;
      } else if (sort === 2) {
        if (new Date(a?.createdAt) < new Date(b?.createdAt)) return 1;
        if (new Date(a?.createdAt) > new Date(b?.createdAt)) return -1;
        return 0;
      }
    });

  // download data

  const downloadData = {
    headers: [
      { label: "Transaction ID", key: "transcationId" },
      { label: "Request Type/Request ID", key: "reqid" },
      { label: "Transaction Type", key: "transactiontype" },
      { label: "Payment Type", key: "paymenttype" },
      { label: "Total Amount", key: "totalamount" },
      { label: "Payment Status", key: "paymentstatus" },
      { label: "User Name", key: "user" },
      { label: "Remittance Status/ID", key: "remittance" },
      ,
    ],
    data: renderData
      ? renderData?.map((ele) => {
          return {
            transcationId: ele?._id,
            reqid: `${" Takeaway"}  ${ele?.order_id}`,
            transactiontype: ele?.payment_method,
            paymenttype: "Scan & Pay",
            totalamount: ele?.amount,
            paymentstatus: `${
              ele?.status === "captured" ? "Paid" : "Un Paid"
            } \n ${moment(ele?.createdAt).format("ll")}  \n ${moment(
              ele?.createdAt
            ).format("LT")}`,
            user: `${ele?.user_id?.first_name}  ${ele?.user_id?.last_name}`,
            remittance: `${ele?.settled ? "Settled" : "-"}`,
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              displayText="Reports"
              backIcon
              link="/superadmin/scanandpaysummaryreport"
              displayText="Back"
            />
            <div className="super-admin-inside-right-side-panel">
              <h4 className="mt-4 mb-4">Scan & Pay Vendor Report</h4>
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <div className="col-3">
                  <div className="d-flex">
                    <Image
                      src={
                        // reportStat?.restaurant_id?.logo_url
                        //   ? reportStat?.restaurant_id?.logo_url
                        //   :
                        `data:image/jpeg;base64,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`
                      }
                      width="90px"
                    />
                    <div className="ml-3">
                      <div className="f18-700">
                        {/* {reportStat?.restaurant_id?.restaurant_name || ""} */}
                      </div>
                      <div className="f14-500">
                        {/* {reportStat?.restaurant_id?.restaurant_address || ""} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Total No. of Transaction",
                        value: `${reportData?.length || 0}`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total Amount",
                        value: `₹ ${reportStat?.total || 0}`,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <SortTopRight
                      setSort={setSort}
                      filterItems={[
                        { title: "Payment Date & Time", disabled: true },
                        { title: "Old to New", disabled: false },
                        { title: "New to Old", disabled: false },
                        // { title: "User Activity", disabled: true },
                        // { title: `Date & Time 🠑`, disabled: false },
                        // { title: "Date & Time 🠓", disabled: false },
                      ]}
                    />
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => setFilter(!filter)}
                    >
                      <img
                        src={require("../../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <CSVDownloader
                        filename={"Scan & Pay Vendor Report"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <FilterMain
                filterOptions={
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Payment Status
                          </InputLabel>
                          <Select
                            value={filterData}
                            onChange={(e) => setFilterData(e.target.value)}
                            //
                            label="Payment Status"
                            inputProps={{
                              name: "Payment Status",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {PAYMENT_STATUS.map((data, index) => {
                              return (
                                <MenuItem value={index} key={index}>
                                  {data}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                }
                show={filter}
                onCancel={() => setFilter(false)}
                onFilter={() => setFilterData_final(filterData)}
              />
              <div className="text-break">
                <div className="col-12 p-0 user-table-reusable-superadmin">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "10%" }} className="f12-700">
                          Transaction <br />
                          ID
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Request Type/ <br />
                          Request ID
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Transaction <br />
                          type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment <br />
                          Type
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Total <br />
                          Amount
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Payment <br />
                          Status
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          User Name
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Remittance <br />
                          Status/ID
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Refund or Cancellation
                          <br /> Status/ID
                        </th>
                      </tr>
                    </thead>
                    {renderData &&
                      renderData.map((data, index) => (
                        <tbody key={index} style={{ wordBreak: "break-word" }}>
                          <tr className="super_admin_all_users_table_body">
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?._id}
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              Takeaway
                              <br />
                              {data?.order_id}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.payment_method}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              Scan & Pay
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              ₹ {data?.amount}
                            </td>
                            <td style={{ width: "10%" }}>
                              {data?.status === "captured" ? (
                                <div className="badge badge-success">Paid</div>
                              ) : (
                                <div className="badge badge-warning">
                                  Un Paid
                                </div>
                              )}
                              <div className="f12-500">
                                {moment(data?.createdAt).format("ll")}
                                <br />
                                {moment(data?.createdAt).format("LT")}
                              </div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.user_id?.first_name}{" "}
                              {data?.user_id?.last_name}
                            </td>
                            <td style={{ width: "10%" }} className="f12-500">
                              {data?.settled ? (
                                <div className="badge badge-success">
                                  Settled
                                </div>
                              ) : (
                                <div>-</div>
                              )}
                            </td>
                            <td style={{ width: "15%" }} className="f12-500">
                              {data?.raxorpay_payment_details?.refund_status
                                ? "Successful"
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScanAndPayVendorReport;
